import Image from "next/legacy/image"
import { Dialog, Transition } from "@headlessui/react"
import XIcon from "public/icons/x-icon.svg"
import { FC, Fragment, useCallback, useMemo, useState } from "react"
import tw from "tailwind-styled-components"
import { OpenCloseRender, OverlayProps } from "../types"

const ImageContainer = tw.div`
  absolute
  top-[22px]
  right-[24px]
  cursor-pointer
`

export type { OpenCloseRender }

export const ModalOverlay: FC<OverlayProps & { includeX?: boolean }> = ({
  onOpen,
  onClose,
  render,
  renderButton,
  includeX = false,
  startOpen = false,
  size = "md",
}) => {
  let [isOpen, setIsOpen] = useState(startOpen)

  const open = useCallback(() => {
    setIsOpen(true)
    onOpen ? onOpen() : null
  }, [onOpen])

  const close = useCallback(() => {
    setIsOpen(false)
    onClose
      ? setTimeout(() => {
          onClose()
        }, 200)
      : null
  }, [onClose])

  const renderedButton = useMemo(() => renderButton({ open, close }), [renderButton, open, close])
  const rendered = useMemo(() => render({ open, close }), [render, open, close])
  return (
    <>
      {renderedButton}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="fixed pin inset-0 z-10 overflow-y-auto" onClose={close}>
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-100"
              enterFrom="opacity-0"
              enterTo="opacity-80"
              leave="ease-in duration-100"
              leaveFrom="opacity-80"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-[#13151A] bg-opacity-90  transition-opacity"></Dialog.Overlay>
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-100"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-100"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div
                className={` ${size == "sm" ? "max-w-sm" : ""} ${size == "md" ? "max-w-md" : ""} ${
                  size == "lg" ? "max-w-4xl" : ""
                } ${
                  size == "xl" ? "max-w-5xl" : ""
                }  text-white inline-block w-full  p-6 my-8 text-left align-middle transition-all transform rounded-2xl shadow-2xl bg-grayscale-dark  border border-white border-1 border-opacity-10`}
              >
                {includeX && (
                  <ImageContainer>
                    <Image
                      alt={"close-icon"}
                      height={`14`}
                      width={`14`}
                      src={XIcon}
                      onClick={close}
                    />
                  </ImageContainer>
                )}
                {rendered}
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
export default ModalOverlay
